import Cleave from 'cleave.js/react';

export function MoneyInput({
  label,
  onChange,
  defaultValue = undefined,
  required = undefined,
}) {
  function handleChange({ target }) {
    const value = Number(target.value.replace(/ /g, ''));

    if (isNaN(value)) {
      return;
    }

    onChange(value);
  }

  return (
    <label className="root">
      <span className="label">{label}</span>
      <div className="inputContainer">
        <Cleave
          placeholder="0"
          options={{
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            delimiter: ' ',
            numeralDecimalMark: ',',
          }}
          inputMode="numeric"
          pattern="[0-9 ]*"
          onChange={handleChange}
          value={defaultValue}
          required={required}
        />
        <span className="inputContainer__suffix">kr</span>
      </div>
      <style jsx>{`
        .root {
          display: block;
          margin-bottom: 18px;
        }

        .label {
          margin-bottom: 9px;
          display: block;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .inputContainer {
          position: relative;
        }

        .inputContainer :global(input) {
          width: 100%;
          box-sizing: border-box;
          height: 50px;
          padding: 0 12px;
          background-color: var(--bgBlueish);
          color: var(--bgBlueish__text);
          border: 3px solid var(--bgBlueish__fadedText);
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          appearance: none;
        }

        .inputContainer :global(input:focus) {
          outline: none;
          border-color: var(--bgBlueish__tintedText);
        }

        .inputContainer__suffix {
          font-size: 16px;
          font-weight: 500;
          position: absolute;
          right: 12px;
          bottom: 16px;
          color: var(--bgBlueish__text);
          user-select: none;
        }
      `}</style>
    </label>
  );
}
